import { Tabs, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getChargeTabLabel, getChargesTabs } from './utils';
import { CustomTab } from './components/CustomTab';
import { useGeneralChargesContext } from 'contexts/GeneralChargesContext';

const useStyles = makeStyles((theme: any) => ({
  tabs: {
    borderBottom: '1px solid lightgray',
    '& .MuiTabs-scroller': {
      overflowX: 'auto !important',
      scrollbarWidth: 'thin',
    },
    '& .MuiTabScrollButton-root': {
      width: theme.spacing(4),
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(3.5),
      },
    },
  },
}));

interface Props {
  orderType: string;
  transactionType: string;
  currentChargeTabSelected: string;
  onTabChange: (tab: string) => void;
}

export const ChargesTabs: FC<Props> = ({
  orderType,
  transactionType,
  currentChargeTabSelected,
  onTabChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isCompact = !useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
  const tabList = useMemo(() => getChargesTabs({ orderType, transactionType }), [orderType, transactionType]);
  const { setAccounting } = useGeneralChargesContext();

  const handleTabChange = (_, value: string) => {
    if (value === currentChargeTabSelected) return;
    setAccounting([]);
    onTabChange(value);
  };

  return (
    <Tabs
      className={classes.tabs}
      orientation="horizontal"
      variant="scrollable"
      scrollButtons={isCompact ? true : 'auto'}
      value={currentChargeTabSelected}
      onChange={handleTabChange}
      id="charges-tabs"
      aria-label="scrollable auto tabs"
    >
      {tabList.map((tab) => (
        <CustomTab
          key={tab.code}
          tooltipTitle={getChargeTabLabel(t, tab)}
          code={tab.code}
          value={tab.code}
          currentValue={currentChargeTabSelected}
          text={getChargeTabLabel(t, tab)}
          compact={isCompact}
        />
      ))}
    </Tabs>
  );
};
